import { Inject, Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { UrlKey, IHttpService } from "@weps/shared-http";
import { RobService } from "../../services/rob/rob.service";
import { VexEstateProfileResponse, VexGetStatusResponse } from "@models/vex.model";
import { GlobalStateStore } from "@services/global-state/global-state.service";

@Injectable({
  providedIn: "root",
})
export class VexService {
  private readonly globalStore = inject(GlobalStateStore);

  constructor(
    @Inject("IHttpService") private httpService: IHttpService,
    private robService: RobService,
  ) {}

  getVexStatus(correlation_id: string): Observable<VexGetStatusResponse> {
    const urlParameters = { correlation_id };
    return this.httpService.doGetRequest<VexGetStatusResponse>(
      UrlKey.vex_get_status_url,
      {},
      urlParameters,
    );
  }

  postVexEstateProfile(): Observable<VexEstateProfileResponse> {
    const estateProfile = this.globalStore.estateProfile?.();
    const estateProfileId = estateProfile?.estateProfileId ?? "";

    const data = { estate_profile_id: estateProfileId };
    return this.httpService.doPostRequest<VexEstateProfileResponse>(
      UrlKey.vex_post_estate_profile_url,
      data,
    );
  }

  updateVexCacheOnly(): Observable<VexEstateProfileResponse> {
    const estateProfile = this.globalStore.estateProfile?.();
    const estateProfileId = estateProfile?.estateProfileId ?? "";

    const data = { estate_profile_id: estateProfileId, cache_only: true };
    return this.httpService.doPostRequest<VexEstateProfileResponse>(
      UrlKey.vex_post_estate_profile_url,
      data,
    );
  }
}
